module.exports = __webpack_public_path__ + "img/p14.d5c85d57.png";